// Lib
import Alpine from "alpinejs";

// Utils
import { initScripts, initAlpineScripts } from "./utils/initScripts";
import { initSmoothAnchorScroll } from "./modules/smoothAnchorScroll";

// Modules


document.addEventListener("DOMContentLoaded", () => {
  initScripts();
  initAlpineScripts();
  Alpine.start();
  initSmoothAnchorScroll();
});
